import api from './apiConfig';

// apiConfig monta gia' `${API_URL}${API_BASE_PATH}`, cioe' /v1, come baseURL: i percorsi qui
// sono relativi a quello, come fanno roleAdminService e roleQueueService.
//
// `rimuoviCoda` e `rimuoviTipo` codificano l'identificatore: il candidate group arriva dai
// BPMN e finisce in un segmento di path. Il backend rifiuta gia' in scrittura un candidate
// group che contenga `/`, perche' li' non sarebbe recuperabile; la codifica copre tutto il
// resto.
const groupService = {
    lista: () => api.get('/groups').then((r) => r.data),
    dettaglio: (id) => api.get(`/groups/${encodeURIComponent(id)}`).then((r) => r.data),
    // Chi sta nel gruppo, con quale ruolo. In sola lettura: l'appartenenza si CAMBIA dalla
    // vista utente (userAdminService.grant), perche' la scrittura riguarda una persona.
    membri: (id) => api.get(`/groups/${encodeURIComponent(id)}/members`).then((r) => r.data),
    crea: (gruppo) => api.post('/groups', gruppo).then((r) => r.data),
    aggiorna: (id, anagrafica) =>
        api.put(`/groups/${encodeURIComponent(id)}`, anagrafica).then((r) => r.data),
    elimina: (id) => api.delete(`/groups/${encodeURIComponent(id)}`),
    aggiungiCoda: (id, candidateGroup) =>
        api.post(`/groups/${encodeURIComponent(id)}/queues`, { candidateGroup }),
    rimuoviCoda: (id, candidateGroup) =>
        api.delete(
            `/groups/${encodeURIComponent(id)}/queues/${encodeURIComponent(candidateGroup)}`,
        ),
    // Fase F6. Ogni coda con i gruppi che la aprono, orfane in testa: e' il catalogo da cui
    // la pagina Gruppi sceglie che cosa legare. Sotto groups.read e NON sotto queues.read,
    // che dalla fase F5 e' filtrato per ambito: chi amministra un gruppo poteva cosi' vedere
    // meno code di quante ne puo' legare, e le code mancanti non erano segnalate da niente.
    // E' lo stesso difetto, e la stessa cura, di `appartenenzaTipi`.
    appartenenzaCode: () => api.get('/groups/queues').then((r) => r.data),
    // Fase F4. Ogni tipo di Codex con i gruppi in cui sta, orfani in testa: e' la diagnosi
    // della pagina dei tipi. Sotto groups.read, perche' cio' che risponde e' l'appartenenza
    // ai gruppi.
    appartenenzaTipi: () => api.get('/groups/codex-types').then((r) => r.data),
    // Fase F4, D2. I tipi dei MIEI gruppi e quali tipi sono orfani: serve all'avviso al
    // caricamento, non a un controllo d'accesso — `codex.create` resta senza ambito.
    // Self-service: parla del solo chiamante e non chiede groups.read, altrimenti l'avviso
    // mancherebbe proprio a chi carica documenti e non amministra nulla.
    mieiTipi: () => api.get('/groups/my-codex-types').then((r) => r.data),
    aggiungiTipo: (id, codexTypeId) =>
        api.post(`/groups/${encodeURIComponent(id)}/codex-types`, { codexTypeId }),
    rimuoviTipo: (id, codexTypeId) =>
        api.delete(
            `/groups/${encodeURIComponent(id)}/codex-types/${encodeURIComponent(codexTypeId)}`,
        ),
};

export default groupService;
